import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function Hero() {
  return <section className="relative w-full min-h-[calc(100vh-180px)] flex items-center overflow-hidden py-20 px-6 bg-teal-dark" style={{
    backgroundImage: "url('https://cdn.magicpatterns.com/uploads/deELFBryk7XWUvcAHjCRJU/FONDO_2.png')",
    backgroundSize: 'cover',
    backgroundPosition: 'center right',
    backgroundRepeat: 'no-repeat'
  }} data-id="element-160">
      {/* Gradient overlay for text legibility on the left */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'linear-gradient(to right, rgba(8,32,31,0.85) 0%, rgba(8,32,31,0.6) 35%, rgba(8,32,31,0.2) 65%, rgba(8,32,31,0) 100%)'
    }} data-id="element-161" />

      <div className="relative max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 z-10" data-id="element-162">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col items-center lg:items-start text-center lg:text-left" data-id="element-163">
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-8 drop-shadow-md" data-id="element-164">
            Hay una capa más profunda en vos
            <br data-id="element-165" />
            que todavía no fue tocada.
          </h1>

          <p className="text-white/90 font-light text-lg md:text-xl mb-12 max-w-lg leading-relaxed" data-id="element-166">
            Depuración y restauración energética a distancia.
            <br data-id="element-167" />
            Sin videollamada. Sin presencial.
            <br data-id="element-168" />
            Solo tu nombre, tu fecha de nacimiento
            <br data-id="element-169" />y lo que querés trabajar — y el trabajo comienza.
          </p>

          <div className="flex flex-col items-center lg:items-start" data-id="element-170">
            <Link to="/sesiones" className="inline-block bg-gold text-teal font-medium px-10 py-4 rounded-full hover:bg-white transition-colors duration-300 tracking-wide mb-4 shadow-lg" data-id="element-171">
              QUIERO MI SESIÓN
            </Link>
            <p className="text-white/80 italic text-sm font-serif" data-id="element-172">
              100% a distancia · Para cualquier parte del mundo
            </p>
          </div>
        </motion.div>

        {/* Right column intentionally empty — the background image carries the visual */}
        <div className="hidden lg:block" aria-hidden="true" data-id="element-173" />
      </div>
    </section>;
}